<form [formGroup]="form">
  <h1 *ngIf="product">{{ product.producer }} {{ product.name }}</h1>
  <div id="modelsWrapper">
    <div class="column">
      <mat-form-field appearance="fill">
        <mat-label>Finisaj</mat-label>
        <mat-select formControlName="finish" [required]="true" (selectionChange)="finishChange()">
          <mat-option *ngFor="let finish of (finishes | async)?.results" [value]="finish">
            <div style="display: flex; align-items: center">
              <img loading="lazy" *ngIf="product.isTile && finish.finish !== 'wood'" height="40"
                   src="{{this.product.getCustomizedImage(finish.finish, getDefaultFinishColor(finish.finish))}}" />
              <mat-icon *ngIf="finish.finish === 'wood' && form.controls.finish.value.finish !== 'wood'" style="font-size: 40px">
                hide_image
              </mat-icon>
              <span style="font-size: 16px; margin-left: 10px">{{ finish.finish | titlecase }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Grosime</mat-label>
        <mat-select formControlName="thickness" [required]="true" (selectionChange)="thicknessChange()">
          <mat-option *ngFor="let thickness of (thicknesses | async)?.results" [value]="thickness">
            {{ thickness.thickness }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Culoare</mat-label>
        <mat-select formControlName="color" [required]="true" (selectionChange)="colorChange()">
          <mat-option *ngFor="let color of (colors | async)?.results" [value]="color">
            <div style="display: flex; align-items: center">
              <img loading="lazy" *ngIf="product.isTile && form.controls.finish.value.finish !== 'wood'" height="40"
                   src="{{product.getCustomizedImage(form.controls.finish.value.finish, color.color)}}" />
              <span style="font-size: 16px; margin-left: 10px">{{ color.color | titlecase }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <p *ngIf="form.controls.thickness.value.discount > 0">
        Pret: <span class="old-price">{{ getFullPrice() | roncurrency }}</span> &nbsp;
        <span
          class="new-price">{{ getFullPrice() | discount: form.controls.thickness.value.discount | roncurrency }}
          / mp</span>
      </p>
      <p *ngIf="!form.controls.thickness.value.discount">
        <span style="font-weight: 500; font-size: 16px">{{ getFullPrice() | roncurrency }} / mp</span>
      </p>
      <em *ngIf="form.controls.thickness.value.discountMinTotal > 0">Reducerea se aplică la comenzi de
        peste {{ form.controls.thickness.value.discountMinTotal | roncurrency }}</em>
      <button mat-raised-button color="primary" (click)="openDialog()" gaEvent="product_add_to_cart" gaCategory="buttons_tracking">
        <mat-icon>shopping_cart</mat-icon>
        Cumpără
      </button>
    </div>
    <div *ngIf="product" class="column description-row">
      <div>
          <h2>Descriere produs</h2>
        <div *ngIf="imagePath">
          <img [alt]="product.producer + ' ' + product.name + ' ' + this.form.controls.finish.value.finish +  ' '+ this.form.controls.thickness.value.thickness + ' RAL '+this.form.controls.color.value.color" [src]="imagePath" />
        </div>
        <p style="text-align: justify;" *ngIf="product.description" [innerHtml]="product.description"></p>
        <table *ngIf="colorWarrantyInYears">
          <thead>
          <tr>
            <th colspan="2" style="text-align: left">Garanție</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <strong>Culoare</strong>
            </td>
            <td>
              {{ colorWarrantyInYears }} ani
            </td>
          </tr>
          <tr>
            <td>
              <strong>Coroziune</strong>
            </td>
            <td>
              {{ corrosionWarrantyInYears }} ani
            </td>
          </tr>
          <tr>
            <td>
              <strong>Durată de viață</strong>
            </td>
            <td>
              {{ corrosionWarrantyInYears }} ani
            </td>
          </tr>
          <tr>
            <td>
              <strong>Certificat de garanție</strong>
            </td>
            <td>
              <a href="https://experttabla.ro/certificat-de-garantie-{{ product.producer.toLowerCase() }}">https://experttabla.ro/certificat-de-garantie-{{ product.producer.toLowerCase() }}/</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="product" style="width: 100%;margin-top: 50px;">
      <h2 style="font-weight: bold;">Specificații produs</h2>
    </div>
    <div class="column">

      <table *ngIf="product">
        <tbody>
        <tr>
          <td>
            <strong>Producător</strong>
          </td>
          <td>
            {{ product.producer }}
          </td>
        </tr>
        <tr *ngIf="form.controls.finish.value.finish">
          <td>
            <strong>Finisaj</strong>
          </td>
          <td>
            {{ form.controls.finish.value.finish | titlecase }}
          </td>
        </tr>
        <tr *ngIf="form.controls.thickness.value.thickness">
          <td>
            <strong>Grosime</strong>
          </td>
          <td>
            {{ form.controls.thickness.value.thickness}}
          </td>
        </tr>
        <tr *ngIf="form.controls.color.value.color">
          <td>
            <strong>Culoare</strong>
          </td>
          <td>
            RAL {{ form.controls.color.value.color}}
          </td>
        </tr>
        <tr *ngIf="product.totalWidth">
          <td>
            <strong>Lățime totală</strong>
          </td>
          <td>
            {{ product.totalWidth }} m
          </td>
        </tr>
        <tr *ngIf="product.effectiveWidth">
          <td>
            <strong>Lățime utilă</strong>
          </td>
          <td>
            {{ product.effectiveWidth }} m
          </td>
        </tr>
        <tr>
          <td>
            <strong>Ghid montaj</strong>
          </td>
          <td>
            <a href="https://experttabla.ro/ghid-montaj-{{ product.producer.toLowerCase() }}">https://experttabla.ro/ghid-montaj-{{ product.producer.toLowerCase() }}/</a>
          </td>
        </tr>
        <tr>
      <td colspan="2">
      </td>
        </tr>
        </tbody>
      </table>

    </div>
    <div class="column">
      <div *ngIf="product?.specifications" [innerHtml]="product.specifications"></div>
    </div>
  </div>
</form>

